export default __webpack_public_path__ + "static/media/Fishing-New-1.9ecee967.png";